var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 8.05 11.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-width:.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-location-on",
    className: "cls-1",
    d: "m4.03.25c-2.08,0-3.77,1.69-3.78,3.77,0,0,0,0,0,0,0,2.83,3.78,7.01,3.78,7.01,0,0,3.78-4.18,3.78-7.01,0-2.08-1.69-3.77-3.77-3.78,0,0,0,0,0,0Zm0,5.12c-.75,0-1.35-.6-1.35-1.35s.6-1.35,1.35-1.35,1.35.6,1.35,1.35h0c0,.75-.6,1.35-1.35,1.35Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoint);
export default __webpack_public_path__ + "static/media/point.23bfc2bda1c1b1ce441e8dc6ffd4e9d3.svg";
export { ForwardRef as ReactComponent };